import type { PortRange } from '#dn-types/role.ts';

/**
 * Returns a string representation of a start and end port.
 */
export function stringifyPortRange(portRange: PortRange | null): string {
  if (!portRange) return 'Any';

  const { from, to } = portRange;
  if (from !== to) {
    return `${from}-${to}`;
  }
  return String(from);
}
